import { useTexte } from '../../texte'

/**
 * The bar while posts wait for their target (#130, 1.117.0).
 *
 * It takes the place of the input line, like the selection bar before it:
 * nothing is written while a target is chosen, and two bars would take half
 * the height of a phone. The chat above stays free to scroll; the pill, the
 * separators and the search take the author to the target as everywhere.
 *
 * **Without a net it says so** and stays: a move is no task for the outbox
 * -- it would meet a chat hours later that is another one by then.
 */
export function Verschiebeleiste({
  anzahl,
  online,
  fehler,
  onAbbrechen,
}: {
  anzahl: number
  online: boolean
  fehler: string | null
  onAbbrechen: () => void
}) {
  const t = useTexte()
  return (
    <div className="auswahlleiste" role="toolbar" aria-label={t.chat.verschieben.knopf} data-verschiebeleiste={anzahl}>
      <button type="button" className="button button--outline button--small" onClick={onAbbrechen}>
        {t.allgemein.abbrechen}
      </button>
      <span className="auswahlleiste__zahl" aria-live="polite">{t.chat.verschieben.leiste(anzahl)}</span>
      {!online && <p className="auswahlleiste__hinweis">{t.allgemein.ohneNetz}</p>}
      {fehler !== null && <p className="auswahlleiste__hinweis" role="alert">{fehler}</p>}
    </div>
  )
}
